import http from "../http";

export function useAdFormatOption() {
  const getFormatOptions = () => http.get('/api/format-options');

  return {
    getFormatOptions,
  }
}
